import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { buildRoomEntityV2 } from "@youm-front/room/util/factory";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { RoomsPastListActions } from "../actions";
import { RoomsListRequestDTO } from "../dto";
import { RoomsPastListService } from "../services";

@Injectable()
export class RoomsPastListEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomsPastListService: RoomsPastListService
  ) {}

  roomsPastList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomsPastListActions.roomsPastList),
      switchMap(() =>
        this.roomsPastListService
          .roomsPastList(new RoomsListRequestDTO({}))
          .pipe(
            mergeMap((_) => [
              RoomsPastListActions.roomsPastListSuccess({
                rooms: _.data.rooms.map((_) => buildRoomEntityV2(_))
              })
            ]),
            catchError((_) => [
              RoomsPastListActions.roomsPastListFailure({ message: _.message })
            ])
          )
      )
    )
  );
}
